'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _invertBy3 = require('lodash/invertBy');

var _invertBy4 = _interopRequireDefault(_invertBy3);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _utils = require('helpers/utils');

var _components = require('components');

var _reactI18next = require('react-i18next');

var _TrackPartHeader = require('components/TrackPartHeader/TrackPartHeader');

var _TrackPartHeader2 = _interopRequireDefault(_TrackPartHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./SharespaceLists.scss');

var SharespaceMediaList = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(SharespaceMediaList, _Component);

  function SharespaceMediaList() {
    var _ref;

    (0, _classCallCheck3.default)(this, SharespaceMediaList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = SharespaceMediaList.__proto__ || (0, _getPrototypeOf2.default)(SharespaceMediaList)).call.apply(_ref, [this].concat(args)));

    _this.state = { checkedTracks: {} };
    return _this;
  }

  (0, _createClass3.default)(SharespaceMediaList, [{
    key: 'onSelectAllClick',
    value: function onSelectAllClick() {
      var isAllTracksSelected = this.state.isAllTracksSelected;

      if (isAllTracksSelected) {
        this.selectNone();
      } else {
        this.selectAll();
      }
    }
  }, {
    key: 'onSelect',
    value: function onSelect() {
      var checkedTracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var onSelect = this.props.onSelect;

      onSelect((0, _invertBy4.default)(checkedTracks).true || []);
    }
  }, {
    key: 'getCheckedTracksArray',
    value: function getCheckedTracksArray(checkedTracks) {
      return (0, _invertBy4.default)(checkedTracks || this.state.checkedTracks || {}).true || [];
    }
  }, {
    key: 'toggleTrackChecked',
    value: function toggleTrackChecked(id) {
      var mediaList = this.props.mediaList;


      var checkedTracks = (0, _extends4.default)({}, this.state.checkedTracks, (0, _defineProperty3.default)({}, id, !this.state.checkedTracks[id]));
      var checkedTracksArr = this.getCheckedTracksArray(checkedTracks);
      this.setState({ checkedTracks: checkedTracks, isAllTracksSelected: checkedTracksArr.length === mediaList.length });
      this.onSelect(checkedTracks);
    }
  }, {
    key: 'selectAll',
    value: function selectAll() {
      var mediaList = this.props.mediaList;

      var checkedTracks = {};
      for (var i = 0; i < mediaList.length; i++) {
        checkedTracks[i + 1] = true;
      }
      this.setState({ checkedTracks: checkedTracks, isAllTracksSelected: true });
      this.onSelect(checkedTracks);
    }
  }, {
    key: 'selectNone',
    value: function selectNone() {
      this.setState({ checkedTracks: {}, isAllTracksSelected: false });
      this.onSelect({});
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          mediaList = _props.mediaList,
          loading = _props.loading,
          partTracks = _props.partTracks,
          project = _props.project;
      var _state = this.state,
          checkedTracks = _state.checkedTracks,
          isAllTracksSelected = _state.isAllTracksSelected;

      var isLocked = !!project.isLocked;

      if (!project.id) {
        return null;
      }

      if (isLocked) {
        return _react2.default.createElement(
          'div',
          { className: 'bold' },
          t('Content will be automatically transferred to your new project.')
        );
      }

      if (!mediaList.length && !loading) {
        return _react2.default.createElement(
          'div',
          null,
          t('Music list is empty')
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'overflow-hidden margin-bottom-10' },
          _react2.default.createElement(
            'div',
            { className: 'hint pull-left' },
            t('Select tracks you want to reuse in your project.')
          ),
          _react2.default.createElement(
            'div',
            { className: styles.selectAllContainer },
            _react2.default.createElement(_components.Checkbox, {
              className: 'padding-5 inline',
              checked: isAllTracksSelected,
              textBefore: t('Select all'),
              onChange: this.onSelectAllClick
            })
          )
        ),
        partTracks.parts.map(function (part) {
          return _react2.default.createElement(
            'div',
            { key: 'part-' + part },
            !!project.multipleBoxsets && _react2.default.createElement(_TrackPartHeader2.default, { part: part }),
            _react2.default.createElement(
              _components.List,
              null,
              partTracks.tracks[part].map(function (trackIndex) {
                return _react2.default.createElement(
                  _components.ListItem,
                  {
                    fullWidth: true,
                    key: mediaList[trackIndex].id,
                    onClick: function onClick() {
                      return _this2.toggleTrackChecked(trackIndex + 1);
                    }
                  },
                  _react2.default.createElement(
                    'div',
                    null,
                    mediaList[trackIndex].filename
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.checkboxCell },
                    _react2.default.createElement(_components.Checkbox, {
                      className: 'padding-5 inline',
                      checked: checkedTracks[trackIndex + 1],
                      onClick: _utils.stopEvent
                    })
                  )
                );
              })
            )
          );
        }),
        loading && _react2.default.createElement(_components.Loader, null)
      );
    }
  }]);
  return SharespaceMediaList;
}(_react.Component), _class3.propTypes = {
  loading: _propTypes2.default.bool,
  mediaList: _propTypes2.default.array,
  onSelect: _propTypes2.default.func,
  partTracks: _propTypes2.default.object,
  project: _propTypes2.default.object,
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  mediaList: [],
  onSelect: _noop3.default,
  partTracks: {},
  project: {}
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSelectAllClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSelectAllClick'), _class2.prototype)), _class2)) || _class);
exports.default = SharespaceMediaList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/ProjectCreate/components/SharespaceMediaList.js
// module id = 2191
// module chunks = 1